import { log } from '../services/production-logger';

/**
 * Migration helper for transitioning from auth context to organization context
 * This provides a compatibility layer during the migration
 */

import { useAuth as useAuthOriginal } from './auth-context';
import { useOrganization } from './organization-context';

/**
 * Enhanced useAuth hook that provides backward compatibility
 * while we migrate components to use useOrganization directly
 */
export const useAuth = () => {
  const authContext = useAuthOriginal();
  const orgContext = useOrganization();
  
  // Merge auth and organization contexts for backward compatibility
  return {
    ...authContext,
    // Organization-related fields now come from organization context
    activeOrganization: orgContext.activeOrganization,
    userMemberships: orgContext.userMemberships,
    switchOrganization: orgContext.switchOrganization,
    getUserOrganizations: orgContext.getUserOrganizations,
  };
};

/**
 * Helper to identify components that need migration
 * Use this in development to log warnings
 */
export const useMigrationWarning = (componentName: string) => {
  const auth = useAuth();
  
  if (process.env.NODE_ENV === 'development') {
    if ('activeOrganization' in auth || 'userMemberships' in auth) {
      log.warn(
        `⚠️ Migration needed: ${componentName} is using organization data from auth context. ` +
        `Please update to use useOrganization() directly for better performance.`
      );
    }
  }
};